import React from 'react';
import { debounce } from '../../utils/helpers';

const SearchBar = ({ onSearch, placeholder = 'Search...', className = '' }) => {
  const handleChange = debounce((val) => onSearch(val), 400);
  return (
    <div className={`search-box ${className}`}>
      <span className="search-icon">🔍</span>
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        onChange={(e) => handleChange(e.target.value)}
      />
    </div>
  );
};

export default SearchBar;
